var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMauritius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4317 10.4348L19.9999 12.1739L37.5681 10.4348C34.176 4.21792 27.5808 3.05176e-05 19.9999 3.05176e-05C12.419 3.05176e-05 5.82381 4.21792 2.4317 10.4348V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43186 29.5653L20.0001 31.3044L37.5683 29.5653C39.1186 26.7238 40.0001 23.4649 40.0001 20L20.0001 18.2609L6.10352e-05 20C6.10352e-05 23.4649 0.881546 26.7238 2.43186 29.5653Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43186 10.4348C0.881546 13.2763 6.10352e-05 16.5352 6.10352e-05 20H40.0001C40.0001 16.5352 39.1186 13.2763 37.5683 10.4348H20.0001H2.43186Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40C27.5808 40 34.176 35.7821 37.5681 29.5653H2.4317C5.82381 35.7821 12.419 40 19.9999 40Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritius);
export default __webpack_public_path__ + "static/media/mauritius.a91af06783b50253e3bb15a5f3560a67.svg";
export { ForwardRef as ReactComponent };